module.exports = __webpack_public_path__ + "static/image-01-b@2x-44722bff15fd3dfbc323847452828328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-01-b@2x.jpg
// module id = 425
// module chunks = 3627797113349 20562973939449 33019919093843